import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Divider,
} from '@mui/material';
import { useAppBar } from '../../providers/AppBarProvider';
import { fetchSpending, formatCurrency, handleError } from '../../utils/lib';
import { useLocation, useNavigate } from 'react-router-dom';
import ViewPage from './ViewPage';
import { useSnackbar } from "../../providers/SnackBarProvider";
import { useConfig } from '../../providers/ConfigProvider';
import BottomSheet from '../../layouts/BottomSheet';
import axios from 'axios';
import DeleteIcon from '@mui/icons-material/Delete';
import useNavigationHelperStore from '../../store/navigationHelperStore';
import { useTranslation } from 'react-i18next';

function ViewSpending() {
  const location = useLocation();
  const navigate = useNavigate();
  const snackbar = useSnackbar();
  const [id, setId] = useState(location.state.id);
  const [spending, setSpending] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const {updateTitle} = useAppBar();
  const {config, isLoadingConfig} = useConfig();
  const { t } = useTranslation();
  
  useEffect(() => {
    const fetchData = async () => {
      try {
        const spending = await fetchSpending(id);
        setSpending(spending);
        updateTitle('', spending.deleted ? t('view.spendingDeletedTitle') : t('view.spendingTitle'));
      } catch (error) {
        handleError(error, snackbar);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, [t]);

  const [deleteDialog, setDeleteDialog] = useState({
    open: false
  });

  const handleDeleteOpen = () => {
    setDeleteDialog({
      open: true
    });
  };

  const handleDeleteClose = () => {
    setDeleteDialog({
      open: false
    });
  };

  const handleDeleteConfirm = async () => {
    try {
      await axios.delete(
        `${import.meta.env.VITE_API_URL}spendings?id=${id}`,
        { withCredentials: true }
      );
      
      handleDeleteClose();
      navigate(-1);
    } catch (error) {
      handleError(error, snackbar);
    }
  };

  if (isLoading || isLoadingConfig || !spending) {
    return <ViewPage isLoading={true} />;
  }

  return (
    <ViewPage 
      isLoading={isLoading || isLoadingConfig}
    >
      <Box sx={{ px: 1 }}>
        <Box sx={{ mb: 2 }}>
          <Typography>{t('common.date')}: {new Date(spending.date).toLocaleString()}</Typography>
          <Typography>{t('common.user')}: {spending.user.name}</Typography>
          <Typography>{t('common.amount')}: {formatCurrency(spending.amount)}</Typography>
          <Typography>{t('common.motive')}: {spending.reason}</Typography>
          <Typography>{t('reports.paymentType')}: {spending.payment_type}</Typography>
        </Box>

        <Divider sx={{ marginY: 2 }} />
      </Box>

      <Dialog
        open={deleteDialog.open}
        onClose={handleDeleteClose}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>{t('view.deleteSpendingTitle')}</DialogTitle>
        <DialogContent>
          {t('view.deleteSpendingMessage')}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteClose}>{t('common.cancel')}</Button>
          <Button onClick={handleDeleteConfirm} variant="contained" color="error">
            {t('common.delete')}
          </Button>
        </DialogActions>
      </Dialog>

      <BottomSheet 
        zIndex={1001}
        buttonGroups={[
          {
            label: t('common.actions'), 
            buttons: [
              ...(config.permissions?.actions_permissions?.spendings?.delete ? [{
                label: t('common.delete'),
                action: handleDeleteOpen,
                icon: <DeleteIcon />
              }] : []),
            ].filter(Boolean)
          }
        ]}
      />
    </ViewPage>
  );
}

export default ViewSpending; 